import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActiveIngredientService } from '../../../active-ingredient.service';
import {
  ACTIVE_INGREDIENT_TTL_ES,
  IActiveIngredientBase
} from '../../../active-ingredient.interface';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';
@Component({
  selector: 'pg-active-ingredient-create',
  templateUrl: './active-ingredient-create.component.html'
})
export class ActiveIngredientCreateComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  constructor(
    private fb: FormBuilder,
    private serviceBase: ActiveIngredientService
  ) {
    super(ACTIVE_INGREDIENT_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.fg = this.fb.group({
      description: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ]
    });
  }

  onSubmit() {
    this.createItem$(this.fg.value as IActiveIngredientBase);
  }
}
